import { Attachment } from "../../shared/models/attachment.model";

export class AttachmentDownloader {
  static downloadFile(blob: Blob, att: any): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = att.fileName || 'download';
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 100);
  }

  static getFileExtension(name: string): string {
    const base = name.split('/').pop() ?? name;
    const i = base.lastIndexOf('.');
    return i > 0 ? base.slice(i + 1).toLowerCase() : '';
  }

  static mimeByExt(ext: string): string | null {
    switch (ext) {
      case 'pdf': return 'application/pdf';
      case 'png': return 'image/png';
      case 'jpg':
      case 'jpeg': return 'image/jpeg';
      case 'gif': return 'image/gif';
      case 'webp': return 'image/webp';
      case 'docx': return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      case 'doc':  return 'application/msword';
      case 'xlsx': return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      case 'pptx': return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
      default: return null;
    }
  }

  static previewFile(fileName: string, blob: Blob) {
    const ext  = this.getFileExtension(fileName);
    const type = blob.type || this.mimeByExt(ext) || 'application/octet-stream';
    const url  = URL.createObjectURL(new Blob([blob], { type }));

    // 1) PDF / images — рендерим прямо во вкладке через iframe (надежнее чем просто window.open(url))
    if (type === 'application/pdf' || type.startsWith('image/')) {
      const w = window.open('', '_blank');
      if (!w) {
        // popup заблокирован — просто открываем ссылку
        window.open(url, '_blank');
      } else {
        const safeTitle = fileName.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        w.document.write(`
          <title>${safeTitle}</title>
          <style>html,body,iframe{margin:0;height:100%;width:100%;border:0}</style>
          <iframe src="${url}" allow="autoplay"></iframe>
        `);
      }
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
      return;
    }

    // 2) DOCX/XLSX/PPTX — браузер не умеет показывать; предложим загрузку
    if (
      ext === 'docx' || ext === 'doc' ||
      ext === 'xlsx' || ext === 'pptx'
    ) {
      // Если у вас есть публичный/подписанный URL файла,
      // можно открыть в Office Viewer:
      // const office = 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(publicUrl);
      // window.open(office, '_blank');

      // Иначе — триггерим скачивание (в новой вкладке это не гарантируется браузером, но файл скачается)
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // подсказываем имя файла
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
      return;
    }

    // 3) Остальные типы — открываем как есть (чаще всего скачается)
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  }

}